import { useEffect, useState } from "react";
import { Card, Col, Row, Tag, Typography } from "antd";
import { platformFeatures } from "../landingData";

const { Title, Paragraph, Text } = Typography;

const calendarAppointments = [
  { time: "9:00 AM", service: "Men's Haircut", color: "blue" },
  { time: "9:30 AM", service: "Highlights", color: "pink" },
  { time: "10:00 AM", service: "Blowout", color: "cyan" },
  { time: "10:30 AM", service: "Color & Cut", color: "purple" },
  { time: "11:00 AM", service: "Beard Trim", color: "green" },
];

const reportsChart = [65, 45, 78, 52, 88, 72, 95, 68, 82, 90, 100, 85];

const clientRows = [
  { name: "Sarah Johnson", visits: 24, spent: "$2,840", last: "2 days ago" },
  { name: "Michael Chen", visits: 15, spent: "$1,650", last: "1 week ago" },
  { name: "Emma Davis", visits: 31, spent: "$4,125", last: "Yesterday" },
  { name: "James Wilson", visits: 8, spent: "$890", last: "3 days ago" },
];

const saleItems = [
  { name: "Men's Haircut", price: "$35.00" },
  { name: "Beard Trim", price: "$20.00" },
  { name: "Hair Gel", price: "$18.00" },
];

const paymentMethods = ["Card", "Cash", "Gift Card", "Card on File"];

const inventoryRows = [
  { name: "Premium Shampoo", stock: 24, price: "$28", low: false },
  { name: "Hair Gel", stock: 8, price: "$18", low: true },
  { name: "Conditioner", stock: 18, price: "$28", low: false },
  { name: "Beard Oil", stock: 5, price: "$24", low: true },
];

function CalendarPreview() {
  return (
    <div className="showcase-preview">
      <div className="showcase-preview-header">
        <Text strong>Today's Schedule</Text>
        <Text type="secondary">Tuesday, April 28</Text>
      </div>
      <div className="showcase-calendar-grid">
        {calendarAppointments.map((appt) => (
          <div key={appt.time} className={`showcase-appt showcase-appt-${appt.color}`}>
            <Text strong>{appt.time}</Text>
            <Text>{appt.service}</Text>
          </div>
        ))}
        <div className="showcase-appt showcase-appt-empty">
          <Text type="secondary">Available</Text>
        </div>
      </div>
    </div>
  );
}

function ReportsPreview() {
  return (
    <div className="showcase-preview">
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card className="showcase-stat-card showcase-stat-green">
            <Text>Today's Revenue</Text>
            <Title level={3}>$2,847</Title>
            <Text className="showcase-stat-delta">↑ 24% from yesterday</Text>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card className="showcase-stat-card showcase-stat-blue">
            <Text>This Month</Text>
            <Title level={3}>$42,500</Title>
            <Text className="showcase-stat-delta">↑ 18% vs last month</Text>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card className="showcase-stat-card showcase-stat-purple">
            <Text>Appointments</Text>
            <Title level={3}>38</Title>
            <Text className="showcase-stat-delta">Today's bookings</Text>
          </Card>
        </Col>
      </Row>
      <Card className="showcase-chart-card">
        <Text strong>Revenue Trend</Text>
        <div className="showcase-bar-chart">
          {reportsChart.map((height, index) => (
            <div key={index} className="showcase-bar" style={{ height: `${height}%` }} />
          ))}
        </div>
      </Card>
    </div>
  );
}

function ClientsPreview() {
  return (
    <div className="showcase-preview">
      <div className="showcase-preview-header">
        <Text strong>Client Database</Text>
        <Text type="secondary">1,247 active clients</Text>
      </div>
      <div className="showcase-client-list">
        {clientRows.map((client) => (
          <div key={client.name} className="showcase-client-row">
            <div className="showcase-client-avatar">
              {client.name.split(" ").map((n) => n[0]).join("")}
            </div>
            <div className="showcase-client-info">
              <Text strong>{client.name}</Text>
              <Text type="secondary">Last visit: {client.last}</Text>
            </div>
            <div className="showcase-client-metrics">
              <Text type="secondary">{client.visits} visits</Text>
              <Text className="showcase-stat-delta">{client.spent}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function PosPreview() {
  return (
    <div className="showcase-preview">
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card className="showcase-pos-card">
            <Text strong>Current Sale</Text>
            {saleItems.map((item) => (
              <div key={item.name} className="split-row showcase-pos-item">
                <Text>{item.name}</Text>
                <Text strong>{item.price}</Text>
              </div>
            ))}
            <div className="showcase-pos-total split-row">
              <Text strong>Total</Text>
              <Text strong className="showcase-stat-delta">$78.84</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card className="showcase-pos-card">
            <Text strong>Payment Method</Text>
            <div className="showcase-payment-grid">
              {paymentMethods.map((method, index) => (
                <div
                  key={method}
                  className={index === 0 ? "showcase-payment-tile active" : "showcase-payment-tile"}
                >
                  <Text>{method}</Text>
                </div>
              ))}
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

function InventoryPreview() {
  return (
    <div className="showcase-preview">
      <div className="showcase-preview-header">
        <Text strong>Product Inventory</Text>
        <Tag color="orange">3 Low Stock</Tag>
      </div>
      <div className="showcase-inventory-table">
        <div className="showcase-inventory-row showcase-inventory-head">
          <Text strong>Product</Text>
          <Text strong>Stock</Text>
          <Text strong>Price</Text>
          <Text strong>Status</Text>
        </div>
        {inventoryRows.map((item) => (
          <div key={item.name} className="showcase-inventory-row">
            <Text>{item.name}</Text>
            <Text>{item.stock}</Text>
            <Text>{item.price}</Text>
            <Tag color={item.low ? "orange" : "green"}>{item.low ? "Low Stock" : "In Stock"}</Tag>
          </div>
        ))}
      </div>
    </div>
  );
}

const showcasePreviews = [
  CalendarPreview,
  ReportsPreview,
  ClientsPreview,
  PosPreview,
  InventoryPreview,
];

export function PlatformShowcaseSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % platformFeatures.length);
    }, 4000);

    return () => window.clearInterval(timer);
  }, []);

  const activeFeature = platformFeatures[currentSlide];
  const ActivePreview = showcasePreviews[currentSlide];

  return (
    <section className="landing-section">
      <Title level={2}>See Hairplane In Action</Title>
      <Paragraph className="landing-section-subtitle">
        A simple, powerful platform designed for salon and barbershop owners.
      </Paragraph>

      <Card className="landing-showcase">
        <div className="landing-browser-bar">
          <span />
          <span />
          <span />
        </div>

        <div className="landing-dashboard-preview">
          <Title level={3}>{activeFeature.title}</Title>
          <Paragraph>{activeFeature.description}</Paragraph>

          <ActivePreview />
        </div>
      </Card>

      <div className="landing-dots">
        {platformFeatures.map((feature, index) => (
          <button
            key={feature.title}
            className={currentSlide === index ? "active" : ""}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to ${feature.title}`}
          />
        ))}
      </div>
    </section>
  );
}
